"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.suggestSrOpts = exports.suggestSpOpts = exports.suggestProductNameOpts = exports.suggestAsmOpts = exports.getStoreSRDATraining = exports.getStoreData = exports.getSaleSRList = exports.getSaleSPList = exports.getSaleRevenueData = exports.getSaleIntegralData = exports.getSaleDisplayData = exports.getSaleDetailLineChart = exports.getSaleASMList = exports.getSRVisitCustomerList = exports.getSRPersonInfo = exports.getReportVisitRecord = exports.getReportSigningMonth = exports.getReportSales = exports.getReportOrderSales = exports.getReportActiveQuarter = exports.getReportActiveMonth = exports.getNewProductsData = exports.getMixData = exports.getKPIOrderSalesList = exports.getCommentSendSingle = exports.getCommentSendBatch = exports.getCommentOrgBiz = exports.getBonusCalculation = exports.getAllPatternOpts = exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _request = _interopRequireDefault(require("@/http/request"));
/**
 * 首页报表
 */
/** package */

// 1.1. (Q_HomeSales)APP首页销售量
var getReportSales = exports.getReportSales = function getReportSales(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/sales",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 1.2. (Q_ActualSalesMonth)月度TPP签约门店报表
var getReportSigningMonth = exports.getReportSigningMonth = function getReportSigningMonth(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/signing/month",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 1.3. (Q_HomeActiveCount)月度TPP活跃门店报表
var getReportActiveMonth = exports.getReportActiveMonth = function getReportActiveMonth(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/active/month",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 1.4. (Q_HomeActiveCountQuarter)季度TPP活跃门店报表
var getReportActiveQuarter = exports.getReportActiveQuarter = function getReportActiveQuarter(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/active/quarter",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 1.5. (Q_OrderSales)首页月度订单销售量
var getReportOrderSales = exports.getReportOrderSales = function getReportOrderSales(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/order/sales",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 1.6. (Q_HomeVisitRecord)首页月度拜访报告
var getReportVisitRecord = exports.getReportVisitRecord = function getReportVisitRecord(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/visit/record",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 1.7. (Q_LeadershipHome)APP AsmRsm 首页销售量 all
var getSaleDisplayData = exports.getSaleDisplayData = function getSaleDisplayData(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: '/protected/app/home/asmRsm/all',
    method: 'post',
    data: data
  });
};
// 5.9. (Q_IntegralReport)积分报表
var getSaleIntegralData = exports.getSaleIntegralData = function getSaleIntegralData(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: '/protected/app/home/performance/queryIntegralReport',
    method: 'post',
    data: data
  });
};
// 5.8. (Q_RevenueReport)金额报表
var getSaleRevenueData = exports.getSaleRevenueData = function getSaleRevenueData(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: '/protected/app/home/performance/queryRevenueReport',
    method: 'post',
    data: data
  });
};
// 1.8. (Q_LeadershipHome)APP AsmRsm 首页销售量 prodSize
var getMixData = exports.getMixData = function getMixData(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: '/protected/app/home/asmRsm/prodSize',
    method: 'post',
    data: data
  });
};

// 1.9. (Q_LeadershipHome)APP AsmRsm 首页销售量 NewProduct
var getNewProductsData = exports.getNewProductsData = function getNewProductsData(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: '/protected/app/home/asmRsm/newProduct',
    method: 'post',
    data: data
  });
};

// 4.4. Leadership首页门店报表
var getStoreData = exports.getStoreData = function getStoreData(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: '/protected/app/home/leader/areaChart/home/store',
    method: 'post',
    data: data
  });
};

// 4.1. 销售表现趋势图
var getSaleDetailLineChart = exports.getSaleDetailLineChart = function getSaleDetailLineChart(data, from) {
  var urlMap = {
    'all': '/protected/app/home/sm/areaChart/performance',
    'prodSize': '/protected/app/home/sm/areaChart/mix',
    'newProdcut': '/protected/app/home/sm/areaChart/newProduct'
  };
  if (!Object.keys(urlMap).includes(from)) {
    alert('参数有误');
    return Promise.reject('参数有误');
  }
  return (0, _request.default)({
    module: 'REPORT',
    url: urlMap[from],
    method: 'post',
    data: data
  });
};

// 1.1. (Q_OrderSalesASMRanking)APP首页销量明细-ASM排名
var getSaleASMList = exports.getSaleASMList = function getSaleASMList(data, from) {
  var urlMap = {
    'all': '/protected/app/home/asmRsm/order/sales/asmRanking',
    'prodSize': '/protected/app/home/asmRsm/size/order/sales/asmRanking',
    'newProdcut': '/protected/app/home/asmRsm/new/product/asmRanking'
  };
  if (!Object.keys(urlMap).includes(from)) {
    alert('参数有误');
    return Promise.reject('参数有误');
  }
  return (0, _request.default)({
    module: 'REPORT',
    url: urlMap[from],
    method: 'post',
    data: data
  });
};

// 1.2. (Q_OrderSalesSRRanking)APP首页销量明细-SR排名
var getSaleSRList = exports.getSaleSRList = function getSaleSRList(data, from) {
  var urlMap = {
    'all': '/protected/app/home/asmRsm/order/sales/SRRanking',
    'prodSize': '/protected/app/home/asmRsm/size/order/sales/SRRanking',
    'newProdcut': '/protected/app/home/asmRsm/new/product/SRRanking'
  };
  if (!Object.keys(urlMap).includes(from)) {
    alert('参数有误');
    return Promise.reject('参数有误');
  }
  return (0, _request.default)({
    module: 'REPORT',
    url: urlMap[from],
    method: 'post',
    data: data
  });
};

// 1.12. (Q_LeadershipHome)APP AsmRsm 首页销售量 NewProductSpRanking
var getSaleSPList = exports.getSaleSPList = function getSaleSPList(data, from) {
  // from: all、newProdcut、prodSize
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/asmRsm/".concat(from, "/spRanking"),
    method: 'post',
    data: data
  });
};
var getCommentOrgBiz = exports.getCommentOrgBiz = function getCommentOrgBiz(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/action/orgBiz",
    method: 'post',
    data: data
  });
};
var getCommentSendSingle = exports.getCommentSendSingle = function getCommentSendSingle(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/action/send",
    method: 'post',
    data: data
  });
};
var getCommentSendBatch = exports.getCommentSendBatch = function getCommentSendBatch(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/action/batchSend",
    method: 'post',
    data: data
  });
};

// 4.7. (Q_SR_VISIT_RECORD)查询SR月度拜访报告
var getSRPersonInfo = exports.getSRPersonInfo = function getSRPersonInfo(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/srVisit/record",
    method: 'post',
    data: data
  });
};

// 4.8. (L_SR_VISIT_RECORD)查询SR月度拜访列表
var getSRVisitCustomerList = exports.getSRVisitCustomerList = function getSRVisitCustomerList(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/srVisit/record/list",
    method: 'post',
    data: data
  });
};
var suggestProductNameOpts = exports.suggestProductNameOpts = function suggestProductNameOpts(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/newProduct/search/size",
    method: 'post',
    data: data
  });
};
var suggestSpOpts = exports.suggestSpOpts = function suggestSpOpts(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/newProduct/search/sp",
    method: 'post',
    data: data
  });
};
var suggestAsmOpts = exports.suggestAsmOpts = function suggestAsmOpts(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/newProduct/search/asm",
    method: 'post',
    data: data
  });
};
var suggestSrOpts = exports.suggestSrOpts = function suggestSrOpts(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/newProduct/search/sr",
    method: 'post',
    data: data
  });
};
var getAllPatternOpts = exports.getAllPatternOpts = function getAllPatternOpts() {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/performance/queryAllProductPattern",
    method: 'post'
  });
};
var getKPIOrderSalesList = exports.getKPIOrderSalesList = function getKPIOrderSalesList(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/report/common/kpi/order/sales/list",
    method: 'post',
    data: data
  });
};
var getStoreSRDATraining = exports.getStoreSRDATraining = function getStoreSRDATraining(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/activeAndSigning",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getBonusCalculation = exports.getBonusCalculation = function getBonusCalculation(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/report/bonusCalculation",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var _default = exports.default = {
  getReportSales: getReportSales,
  getReportSigningMonth: getReportSigningMonth,
  getReportActiveMonth: getReportActiveMonth,
  getReportActiveQuarter: getReportActiveQuarter,
  getReportOrderSales: getReportOrderSales,
  getReportVisitRecord: getReportVisitRecord,
  getSaleDisplayData: getSaleDisplayData,
  getMixData: getMixData,
  getNewProductsData: getNewProductsData,
  getStoreData: getStoreData,
  getSaleDetailLineChart: getSaleDetailLineChart,
  getCommentOrgBiz: getCommentOrgBiz,
  getCommentSendSingle: getCommentSendSingle,
  getCommentSendBatch: getCommentSendBatch,
  suggestProductNameOpts: suggestProductNameOpts,
  suggestSpOpts: suggestSpOpts,
  suggestAsmOpts: suggestAsmOpts,
  suggestSrOpts: suggestSrOpts,
  getAllPatternOpts: getAllPatternOpts,
  getKPIOrderSalesList: getKPIOrderSalesList
};